<template>
  <div>
    <div
      class="sectionSubtitle"
      data-automation="stats-unique-package-downloads-title"
    >
      Unique Package Downloads
    </div>
    <ChartPlaceholder
      v-if="showPlaceholder"
      :downloading="gettingDownloadsByDay"
    />
    <StatsDailyChart
      v-else
      :daily-data="uniqueDownloadsByDay"
      :cumulative-data="totalUniqueDownloadsByDay"
      :period="period"
      cumulative-label="total"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import StatsDailyChart from './StatsDailyChart'
import ChartPlaceholder from './ChartPlaceholder'

export default {
  name: 'StatsUniqueDownloadsChart',
  components: {
    StatsDailyChart,
    ChartPlaceholder,
  },
  props: {
    period: {
      type: Number,
      required: true,
    },
    sourceType: {
      type: String, // should probably be an enum. Takes values of either 'r' or 'pypi'
      required: true,
    },
  },
  computed: {
    ...mapState({
      gettingDownloadsByDay: state => state.stats.gettingDownloadsByDay,
    }),
    ...mapGetters([
      'downloadsByDay',
      'uniqueDownloadsByDay',
      'totalUniqueDownloadsByDay',
    ]),
    showPlaceholder: function () {
      return !this.downloadsByDay || this.downloadsByDay.length === 0
    },
  },
}
</script>
